// Little Serein site configuration.
export const SITE = {
  name: "Little Serein",
  founderName: "Jicy Joy",
  tagline: "Emotionally aware childhoods begin here",
  mantraCareUrl:
    "https://therapists.therapymantra.co/list/therapist/295209/jicy-joy?pay=true",
  whatsappNumber: "918217588934",
  whatsappMessage:
    "Hello Little Serein, I would like to enquire about a counselling session.",
  instagramUrl: "https://www.instagram.com/hello.little.serein",
  instagramHandle: "@hello.little.serein",
  linkedinUrl: "https://www.linkedin.com/in/jicy-joy-26b0a0249",
  email: "littleserein26@gmail.com",
  price: "\u20B9800",
  sessionLength: "50 minutes",
  availability: "Mon\u2013Fri 5\u20138 PM \u00B7 Sat\u2013Sun 10 AM\u20136 PM",
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1714976694810-85add1a29c96?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwxfHx0aGVyYXBpc3QlMjBsaXN0ZW5pbmclMjB3YXJtbHklMjBjb25zdWx0YXRpb258ZW58MHx8fHwxNzkwNjcwNDEyfDA&ixlib=rb-4.1.0&q=85",
  founder: "/founder.webp",
  childDev:
    "https://images.unsplash.com/photo-1537655780520-1e392ead81f2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwxfHxjaGlsZCUyMHBsYXklMjB0aGVyYXB5fGVufDB8fHx8MTc5MDY2NTM2OHww&ixlib=rb-4.1.0&q=85",
  anxiety:
    "https://images.unsplash.com/photo-1758273240331-745ccab011a2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwyfHxjaGlsZCUyMHBzeWNob2xvZ3klMjBjb3Vuc2VsaW5nfGVufDB8fHx8MTc5MDY2NTM2OHww&ixlib=rb-4.1.0&q=85",
  family:
    "https://images.unsplash.com/photo-1588979355313-6711a095465f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHxmYW1pbHklMjBjb3Vuc2VsaW5nJTIwdGhlcmFweXxlbnwwfHx8fDE3OTA2NjUzNjh8MA&ixlib=rb-4.1.0&q=85",
};

export const waLink = `https://wa.me/${SITE.whatsappNumber}?text=${encodeURIComponent(
  SITE.whatsappMessage
)}`;
